<template>
    <v-card style="height:100% !important">
      <v-toolbar dark color="secondary" height="80" class="pt-3">
          <v-select
          style="height: 100%; margin-left:10px;"
          :items="data"
          item-text="title"
          label="Verfügbare Umfragen"
          outlined
          @input="itemSelected"
          return-object
          dense
        ></v-select>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="closeDialog" class="mt-2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <div id="viewerFrame" v-if="selectedSurvey.length != 0">
        <PXSurvey :schema="JSON.parse(selectedSurvey.schema)" :displayMode="'display'"/>
      </div>
      <v-btn color="primary" id="footerButton" @click="sendSurvey">Umfrage versenden</v-btn>
      <SurveySendDialog ref="sendSurvey" :surveyId="selectedSurvey.id"/>
      <v-snackbar
        timeout="-1"
        v-model="snackbar"
      >
      {{ snackbarText }}
    </v-snackbar>
    </v-card>
</template>


<script>
import pxSurveyService from "./px-survey-service"
import PXSurvey from "@/components/common/PXSurvey.vue"
import SurveySendDialog from './SurveySendDialog.vue';
export default {
  name: "PreviewSurveyProcessModelMenu",
  components:{
    PXSurvey,
    SurveySendDialog
  },
  props:{
    surveys: Array
  },
  data() {
    return {
      data: null,
      selectedSurvey: [],
      sendSurveyDialog: false,
      snackbar: false,
      snackbarText: null
    }
  },
  mounted(){
    this.data = this.surveys;
  },
  methods: {
    itemSelected(item){
      this.selectedSurvey = item;
    },
    sendSurvey(){
      this.$refs.sendSurvey
          .open()
          .then(() => {
            this.snackbar = true;
            this.snackbarText = 'Umfrage wurde erfolgreich versendet!';
            setTimeout(()=> {
              this.snackbar = false;
            }, 2000)
          });
    },
    closeDialog(){
      this.selectedSurvey = [];
      this.sendSurvey = false;
      this.$emit("closeSurveyView");
    }
  }
};
</script>

<style>
#footerButton{
  position: absolute;
  bottom: 15px;
  width:100%;
  background-color: #F5F5F5;
  height:32px;
}
#viewerFrame{
  position: absolute;
  right: 0;
  bottom: calc(15px + 32px);
  top:64px;
  left: 0;
  overflow: auto;
}
</style>